import styled from "styled-components";
import { Colors } from "@tvg/design-system";

export const NavigationContainer = styled.div<{
  colors: Colors;
}>`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${({ colors }) => colors.blue["100"]};
  background-color: ${({ colors }) => colors.white["900"]};
`;
